// :cow: Cosmose CONFIDENTIAL :iso:
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { clientsRequested } from '../../store/select-client.actions';
import { select, Store } from '@ngrx/store';
import { selectClientsResponse, selectClientsResponseError, selectIsLoading } from '../../store/select-client.selectors';
import { selectDecodedToken } from '@coa/app/auth/store/auth.selectors';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from '../../models/client';

@Component({
  selector: 'coa-select-client',
  templateUrl: './select-client.component.html',
  styleUrls: ['./select-client.component.scss'],
})
export class SelectClientComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatMenuTrigger, {static: false}) trigger: MatMenuTrigger;
  isMenuOpened = false;
  clients: Client[];
  selectedClientId: number;

  clientIds$ = this.store$.pipe(
    select(selectDecodedToken),
    map(token => token ? token.business_client_ids : undefined),
  );
  clientsResponse$ = this.store$.pipe(select(selectClientsResponse));
  isLoading$ = this.store$.pipe(select(selectIsLoading));
  clientsResponseError$ = this.store$.pipe(select(selectClientsResponseError));

  private unsubscribe$ = new Subject<void>();

  constructor(
    private store$: Store,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.requestClients();
    this.assignClientIdFromParams();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngAfterViewInit(): void {
    this.trigger.menuOpened.pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe(() => this.isMenuOpened = true);

    this.trigger.menuClosed.pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe(() => this.isMenuOpened = false);
  }

  onSelectClient(id: number): void {
    this.router.navigate(['/clients', id, 'dashboard']);
  }

  private assignClientIdFromParams(): void {
    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(params => {
        this.selectedClientId = parseInt(params.clientId, 10);
      });
  }

  private requestClients(): void {
    this.store$.dispatch(clientsRequested());
  }
}
